import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory, Link } from "react-router-dom";
import axios from 'axios';
import ConfigData from '../../config.json';
import { GolbalDataContext } from '../../components/store/global-data-provider';
import { Button, Col, Container, Input, Row, Tooltip, UncontrolledTooltip } from 'reactstrap';
import Select from 'react-select';
import TableDashboard from '../../components/common/table-dashboard';
import { groupStatusToPage } from '../../components/model/static-data';
import { CapitalizeFirstLetter } from '../../components/utils/format-value';

const RequestFormList = () =>{
    const { tablename } = useParams();
    const history = useHistory();
    const { changeTitlePage } = useContext(GolbalDataContext);
    const [formTemp, setFormTemp] = useState({});
    const [txtSearch, setTxtSearch] = useState("");
    const [selectBusinessUnit, setSelectBusinessUnit] = useState("");
    const [selectLegalTeam, setSelectLegalTeam] = useState("");
    const [selectStatusRequest, setSelectStatusRequest] = useState("");
    const [ddlBusinessUnit, setDdlBusinessUnit] = useState([]);
    const [ddlLegalTeam, setDdlLegalTeam] = useState([]);
    const [ddlStatusRequest, setDdlStatusRequest] = useState([]);
    const [lableBusinessUnit, setLableBusinessUnit] = useState("BU");
    const [dataRequests, setDataRequests] = useState([]);
    const [columnInTable, setColumnInTable] = useState([]);
    const [dataInTable, setDataInTable] = useState([]);
    const userEmail = (!localStorage.getItem("emd")) ? "--" : atob(localStorage.getItem("emd"));

    useEffect(() => {
        let strTableName = "";
        try{
            strTableName = atob(tablename);
        }catch(error){
            strTableName = ""
        }
        if (strTableName === "") {
            history.push("/all-type-request");
        }
        SetColumnInTable(strTableName);
        LoadDataTable(strTableName);
        LoadFormTemp(strTableName);
        LoadDataBusinessunit();
        LoadDataLegalTeam();
        LoadDataWorkflowGroup();
    }, []);

    const OnClickDetail = (data) => {
        let reqId = btoa(data.id);
        let urlPage;
        let url;
        urlPage = groupStatusToPage.find((e) => {
            return e.workflow_status.includes(data.id_workflow_status);
        });

        const checkUserCreateRequestBy = (
            data.create_request_by !== userEmail 
            || data.create_request_by === data.request_by 
            || data.id_workflow_status > 3
        );

        if(typeof(urlPage) !== "undefined"){
                if( checkUserCreateRequestBy ) { // check user if create_request_by ?
                    url = urlPage.url_page.replace(":id", reqId);
                    history.push(url);
                } else {
                    url = "/summary-request/"+reqId;
                    history.push(url);
                }
        } else {
            // case draft
            if(data.id_workflow_status === 0){
                url = "/request/"+reqId;
                history.push(url);
            }
        }
    };

    const OnClickBack = () => {
        history.push("/all-type-request");
    };

    const OnSearch = (strSearch, bu, legalTeam, statusRequestName) => {
        let arrData = dataRequests;
        if(bu !== "" && bu !== null && bu !== undefined){
            arrData = arrData.filter((e) => e.id_business_unit === bu);
        }
        if(legalTeam !== "" && legalTeam !== null && legalTeam !== undefined){
            arrData = arrData.filter((e) => e.accept_request_by.includes(legalTeam));
        }
        if(statusRequestName !== "" && statusRequestName !== null && statusRequestName !== undefined){
            arrData = arrData.filter((e) => e.workflow_group_name === statusRequestName);
        }

        if(strSearch !== null && strSearch !== ""){
            arrData = arrData.filter((item) => {
                let dataMap = item.request_no + " " + item.request_date + " " + item.business_unit_name_en + " " + item.counterparty_name + " " + item.purpose + " " + item.accept_request_by + " " + item.workflow_group_name;               
                dataMap = dataMap.toLocaleLowerCase();
                return dataMap.includes(strSearch.toLocaleLowerCase());
            });
        }

        setDataInTable(arrData);
    };

    const SetColumnInTable = (tableName) => {
        let columns = [];
        if(tableName === "CSA" || tableName === "NDA"){
            columns = [
                {
                    key: "request_no",
                    name: <span className='font-weight-bold'>Request No.</span>,
                    cell: (row, index) => row.request_no,
                    width: "10%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: false
                },
                {
                    key: "request_date",
                    name: <span className='font-weight-bold'>Date Created</span>,
                    cell: (row, index) => row.request_date,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "business_unit_name_en",
                    name: <span className='font-weight-bold'>BU</span>,
                    cell: (row, index) => row.business_unit_name_en,
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "counterparty_name",
                    name: <span className='font-weight-bold'>Counter Party</span>,
                    cell: (row, index) => row.counterparty_name,
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "purpose",
                    name: <span className='font-weight-bold'>purpose</span>,
                    cell: (row, index) => {
                        const showPurpose = (row.purpose !== null && row.purpose !== "") ? row.purpose.substring(0, 70) : "";
                        return (
                            <div style={{cursor: "pointer"}}>
                                <label id={"purpose" + index}>{showPurpose}</label>
                                <UncontrolledTooltip target={"purpose" + index}
                                    placement="right"
                                >
                                    {row.purpose}
                                </UncontrolledTooltip>
                            </div>    
                        );
                    },
                    width: "18%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "accept_request_by",
                    name: <span className='font-weight-bold'>Legal Team</span>,
                    cell: (row, index) => {
                        const emails = row.accept_request_by.replaceAll(',', '\n,');
                        return(
                            <label>{emails}</label>
                        );
                    },
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "workflow_group_name",
                    name: <span className='font-weight-bold'>Status</span>,
                    cell: (row, index) => {
                        return (
                            <label style={{color: (row.workflow_color !== "") ? row.workflow_color : ""}}>
                                {(row.workflow_group_name !== "" && row.workflow_group_name !== null) ? CapitalizeFirstLetter(row.workflow_group_name) : "Draft"}
                            </label>
                        );
                    },
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                }
            ];
        }else if(tableName === "POA"){
            columns = [
                {
                    key: "request_no",
                    name: <span className='font-weight-bold'>Request No.</span>,
                    cell: (row, index) => row.request_no,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: false
                },
                {
                    key: "request_date",
                    name: <span className='font-weight-bold'>Date Created</span>,
                    cell: (row, index) => row.request_date,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "business_unit_name_en",
                    name: <span className='font-weight-bold'>Company Name</span>,
                    cell: (row, index) => row.business_unit_name_en,
                    width: "21%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "purpose",
                    name: <span className='font-weight-bold'>Purpose</span>,
                    cell: (row, index) => {
                        const showPurpose = (row.purpose !== null && row.purpose !== "") ? row.purpose.substring(0, 70) : "";
                        return (
                            <div style={{cursor: "pointer"}}>
                                <label id={"purpose" + index}>{showPurpose}</label>
                                <UncontrolledTooltip target={"purpose" + index}
                                    placement="right"
                                >
                                    {row.purpose}
                                </UncontrolledTooltip>
                            </div>    
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "accept_request_by",
                    name: <span className='font-weight-bold'>Legal Team</span>,
                    cell: (row, index) => {
                        const emails = row.accept_request_by.replaceAll(',', '\n,');
                        return(
                            <label>{emails}</label>
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "workflow_group_name",
                    name: <span className='font-weight-bold'>Status</span>,
                    cell: (row, index) => {
                        return (
                            <label style={{color: (row.workflow_color !== "") ? row.workflow_color : ""}}>
                                {(row.workflow_group_name !== "" && row.workflow_group_name !== null) ? CapitalizeFirstLetter(row.workflow_group_name) : "Draft"}
                            </label>
                        );
                    },
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                }
            ];
        }else if(tableName === "LDR"){
            columns = [
                {
                    key: "request_no",
                    name: <span className='font-weight-bold'>Request No.</span>,
                    cell: (row, index) => row.request_no,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: false
                },
                {
                    key: "request_date",
                    name: <span className='font-weight-bold'>Date Created</span>,
                    cell: (row, index) => row.request_date,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "business_unit_name_en",
                    name: <span className='font-weight-bold'>Company's Work</span>,
                    cell: (row, index) => row.business_unit_name_en,
                    width: "21%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "purpose",
                    name: <span className='font-weight-bold'>purpose</span>,
                    cell: (row, index) => {
                        const showPurpose = (row.purpose !== null && row.purpose !== "") ? row.purpose.substring(0, 70) : "";
                        return (
                            <div style={{cursor: "pointer"}}>
                                <label id={"purpose" + index}>{showPurpose}</label>
                                <UncontrolledTooltip target={"purpose" + index}
                                    placement="right"
                                >
                                    {row.purpose}
                                </UncontrolledTooltip>
                            </div>    
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "accept_request_by",
                    name: <span className='font-weight-bold'>Legal Team</span>,
                    cell: (row, index) => {
                        const emails = row.accept_request_by.replaceAll(',', '\n,');
                        return(
                            <label>{emails}</label>
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "workflow_group_name",
                    name: <span className='font-weight-bold'>Status</span>,
                    cell: (row, index) => {
                        return (
                            <label style={{color: (row.workflow_color !== "") ? row.workflow_color : ""}}>
                                {(row.workflow_group_name !== "" && row.workflow_group_name !== null) ? CapitalizeFirstLetter(row.workflow_group_name) : "Draft"}
                            </label>
                        );
                    },
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                }
            ];
        }else if(tableName === "DBD"){
            columns = [
                {
                    key: "request_no",
                    name: <span className='font-weight-bold'>Request No.</span>,
                    cell: (row, index) => row.request_no,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: false
                },
                {
                    key: "request_date",
                    name: <span className='font-weight-bold'>Date Created</span>,
                    cell: (row, index) => row.request_date,
                    width: "12%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "business_unit_name_en",
                    name: <span className='font-weight-bold'>BU</span>,
                    cell: (row, index) => row.business_unit_name_en,
                    width: "21%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "purpose",
                    name: <span className='font-weight-bold'>purpose</span>,
                    cell: (row, index) => {
                        const dataPurpose = (row.purpose !== null && row.purpose !== "") ? row.purpose.substring(0, 70) : "";
                        const showPurpose = dataPurpose.replaceAll(',', '\n, ');
                        return (
                            <div style={{cursor: "pointer", whiteSpace: "pre-wrap"}}>
                                <label id={"purpose" + index}>{showPurpose}</label>
                                <UncontrolledTooltip target={"purpose" + index}
                                    placement="right"
                                    style={{whiteSpace: "pre-wrap"}}
                                >
                                    {row.purpose.replaceAll(',', '\n, ')}
                                </UncontrolledTooltip>
                            </div>    
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "accept_request_by",
                    name: <span className='font-weight-bold'>Legal Team</span>,
                    cell: (row, index) => {
                        const emails = row.accept_request_by.replaceAll(',', '\n,');
                        return(
                            <label>{emails}</label>
                        );
                    },
                    width: "20%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                },
                {
                    key: "workflow_group_name",
                    name: <span className='font-weight-bold'>Status</span>,
                    cell: (row, index) => {
                        return (
                            <label style={{color: (row.workflow_color !== "") ? row.workflow_color : ""}}>
                                {(row.workflow_group_name !== "" && row.workflow_group_name !== null) ? CapitalizeFirstLetter(row.workflow_group_name) : "Draft"}
                            </label>
                        );
                    },
                    width: "15%",
                    classHeader: "text-start",
                    classBody: "text-start",
                    sortable: true
                }
            ];
        }
        setColumnInTable(columns);
    };

    const LoadFormTemp = (strTableName) => {
        let url = ConfigData.API_URL + "form-temp/search-form-temp-table-name?table_name=" + strTableName + "&status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                changeTitlePage("All " + ((respData.data[0].name_en_sub_request_type !== "" && respData.data[0].name_en_sub_request_type !== null) ? respData.data[0].name_en_sub_request_type.toLowerCase() : respData.data[0].name_en_request_type.toLowerCase()) + " request");
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataBusinessunit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString(),
                    };
                });
                setDdlBusinessUnit(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataLegalTeam = () => {
        let url = ConfigData.API_URL + "user/?status=1&legal_team=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.email,
                        value: e.id.toString(),
                    };
                });
                setDdlLegalTeam(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataWorkflowGroup = () => {
        let url = ConfigData.API_URL + "workflow/ddl-group";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.group_name,
                        value: e.code,
                    };
                });
                const additionalOptions = [
                    { label: "rejected", value: 11 }, // กำหนด value เป็น 11
                    { label: "cancel", value: 12 },   // กำหนด value เป็น 12
                ];

                // รวม array ทั้งสองเข้าด้วยกัน
                const finalArrData = [...arrData, ...additionalOptions];

                setDdlStatusRequest(finalArrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataTable = (tableName) => {
        let url = "";
        if(tableName === "CSA"){
            url = ConfigData.API_URL + "request/csa/email/" + userEmail;
        }else if(tableName === "NDA"){
            url = ConfigData.API_URL + "request/nda/email/" + userEmail;
        }else if(tableName === "LDR"){
            url = ConfigData.API_URL + "request/ldr/email/" + userEmail;
        }else if(tableName === "DBD"){
            url = ConfigData.API_URL + "request/dbd/email/" + userEmail;
        }

        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataInTable(respData.data);
                setDataRequests(respData.data);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="request-form-list">
                        <Col xl={12}>
                            <Row className="align-items-center rfl-div-header">
                                <Col lg={6} md={6} sm={6} xs={7}>
                                    <div className="rfl-div-header-title">
                                        <span className="material-symbols-outlined rfl-dht-icon">description</span>
                                        <p className="rfl-dht-title">Tracking Contract</p>
                                    </div>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={5}>
                                    <Link to={"/create-request/" + btoa(formTemp.table_name)} >
                                        <Button 
                                            className="float-end" 
                                            color="primary" 
                                            style={{borderRadius:'8px', height:'50px'}} 
                                            type="button" 
                                        >
                                            <i className="mdi mdi-plus"></i> Create Form
                                        </Button>
                                    </Link>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} md={6} sm={12} className="mb-2">
                                    <div className="form-icon right mb-2">
                                        <Input 
                                            className="form-control input-search" 
                                            type="text" 
                                            id="txtSerachTable" 
                                            placeholder="Search" 
                                            value={txtSearch || ""} 
                                            onChange={(e) => {
                                                setTxtSearch(e.target.value);
                                                OnSearch(e.target.value, selectBusinessUnit?.value, selectLegalTeam?.label, selectStatusRequest?.label);
                                            }} 
                                        />
                                        <i className="ri-search-2-line"></i>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="align-items-center">
                                <Col lg={3} md={4} sm={12} className="mb-3">
                                    <div className="rfl-select-bu">
                                    <Select id="ddlBusinessUnit"
                                        name="ddl-business-unit"
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: selectBusinessUnit || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                borderRadius: '24px',
                                                color: selectBusinessUnit || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                            }),
                                            placeholder: (provided, state) => ({
                                                ...provided,
                                                color: selectBusinessUnit || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                            }),
                                            dropdownIndicator: (provided, state) => ({
                                                ...provided,
                                                color: selectBusinessUnit || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                            }),
                                            clearIndicator: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // สีของ "x"
                                                '&:hover': {
                                                    color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                },
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                            }),
                                        }}
                                        options={ddlBusinessUnit}
                                        placeholder={lableBusinessUnit}
                                        value={selectBusinessUnit}
                                        onChange={(selected) => {
                                            setSelectBusinessUnit(selected);
                                            OnSearch(txtSearch, selected?.value, selectLegalTeam?.label, selectStatusRequest?.label);
                                            // const params = prepareSearchParams(selected?.value, "selectShowFormType");
                                            //     onSearch(params.txtSearch, params.selectShowFormType, params.selectShowRequestBy, params.selectShowBusinessunit, params.selectShowLegalTeam);
                                        }}
                                        isClearable={true}
                                        isSearchable={true}
                                    />
                                    </div>
                                </Col>
                                <Col lg={3} md={4} sm={12} className="mb-3">
                                    <Select id="ddlLegalTeam"
                                        name="ddl-legal-team"
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: selectLegalTeam || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                borderRadius: '24px',
                                                color: selectLegalTeam || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                            }),
                                            placeholder: (provided, state) => ({
                                                ...provided,
                                                color: selectLegalTeam || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                            }),
                                            dropdownIndicator: (provided, state) => ({
                                                ...provided,
                                                color: selectLegalTeam || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                            }),
                                            clearIndicator: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // สีของ "x"
                                                '&:hover': {
                                                    color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                },
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                            }),
                                        }}
                                        options={ddlLegalTeam}
                                        placeholder="Legal Team"
                                        value={selectLegalTeam}
                                        onChange={(selected) => {
                                            setSelectLegalTeam(selected);
                                            OnSearch(txtSearch, selectBusinessUnit?.value, selected?.label, selectStatusRequest?.label);
                                        }}
                                        isClearable={true}
                                        isSearchable={true}
                                    />
                                </Col>
                                <Col lg={2} md={3} sm={12} className="mb-3">
                                    <Select id="ddlStatusRequest"
                                        name="ddl-status-request"
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: selectStatusRequest || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                borderRadius: '24px',
                                                color: selectStatusRequest || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                            }),
                                            placeholder: (provided, state) => ({
                                                ...provided,
                                                color: selectStatusRequest || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                            }),
                                            dropdownIndicator: (provided, state) => ({
                                                ...provided,
                                                color: selectStatusRequest || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                            }),
                                            clearIndicator: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // สีของ "x"
                                                '&:hover': {
                                                    color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                },
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                            }),
                                        }}
                                        options={ddlStatusRequest}
                                        placeholder="Status"
                                        value={selectStatusRequest}
                                        onChange={(selected) => {
                                            setSelectStatusRequest(selected);
                                            OnSearch(txtSearch, selectBusinessUnit?.value, selectLegalTeam?.label, selected?.label);
                                        }}
                                        isClearable={true}
                                        isSearchable={true}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-5">
                                <Col lg={12}>
                                    <TableDashboard data={dataInTable} column={columnInTable} OnClickDetail={OnClickDetail} />
                                </Col>
                            </Row>
                            <div className="page-footer">
                                <div className="layout-width-footer">
                                    <div className="navbar-footer2">
                                        <Button type="button" className="rfl-btn-back" onClick={(e) => { OnClickBack(); }}>
                                            Back
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RequestFormList;